<template>
  <div id="app">
    <!-- Barra promocional con idioma -->
    <PromotionalBar :selectedLang="selectedLang" />

    <!-- Barra de navegación -->
    <NavBar :selectedLang="selectedLang" @update-lang="updateLang" />

    <!-- Contenido de la ruta activa -->
    <router-view :selectedLang="selectedLang" @update-lang="updateLang" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import PromotionalBar from '@/components/PromotionalBar.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    PromotionalBar
  },
  data() {
    return {
      selectedLang: 'es' // Idioma por defecto
    };
  },
  methods: {
    updateLang(lang) {
      this.selectedLang = lang;
    }
  }
};
</script>

<style>
body {
  margin: 0;
  background-color: #fff;
}
/* .offcanvas-backdrop.show {
  opacity: 0 !important;
} */
</style>
